<template>
  <div class="cbg-white-container blog-details-main">
    <div class="col-sm-12 px-0 flex-end mb-2">
      <!-- DELETE BUTTON -->
      <span
        v-if="
          (newsDetails.is_published === true &&
            newsDetails.status === 'PUBLISHED') ||
          (newsDetails.is_published === false &&
            newsDetails.status === 'UNPUBLISHED')
        "
      >
        <v-btn
          v-if="permissions.includes('CAN_DELETE_NEWS_LISTING')"
          :disabled="
            newsDetails.is_published && newsDetails.status === 'PUBLISHED'
          "
          color="error"
          class="mr-4"
          @click="openSwal('delete', newsDetails._id)"
          >Delete</v-btn
        >
      </span>

      <!-- UNPUBLISH BUTTON -->
      <span
        v-if="!!newsDetails.is_published && newsDetails.status === 'PUBLISHED'"
      >
        <v-btn
          v-if="permissions.includes('CAN_UNPUBLISH_NEWS_LISTING')"
          color="success"
          @click="openSwal('unpublish', newsDetails._id)"
          >Unpublish</v-btn
        >
      </span>

      <!-- PUBLISH BUTTON -->
      <span v-else>
        <v-btn
          v-if="permissions.includes('CAN_PUBLISH_NEWS_LISTING')"
          color="success"
          @click="openSwal('publish', newsDetails._id)"
          >Publish</v-btn
        >
      </span>
      <!-- <v-btn color="success" >Unpublish</v-btn> -->
    </div>
    <div class="blog-image">
      <image-view
        :src="
          newsDetails.cover_photo
            ? newsDetails.cover_photo
            : '/img/avatars/default-user.png'
        "
        alt="user image"
      ></image-view>
    </div>
    <div>
      <h5 class="mt-3 text-capitalize">{{ newsDetails.title }}</h5>
      <!-- <p>
        {{ newsDetails.short_description }}
      </p>-->
      <p class="mb-0">
        By DocSmart
        <b>{{ getNewsDate(newsDetails.updated_at) }}</b>
      </p>
      <div class="col-sm-12 p-0 blog-links d-just-space my-4">
        <div class="share-blog d-align">
          <share-blogs></share-blogs>
        </div>
        <div class="mb-2">
          <div class="d-flex">
            <div class="blog-count mr-3 d-align">
              <image-view
                :src="'/img/avatars/visibility.png'"
                class="mr-1"
              ></image-view>
              <p class="mb-0">{{ newsDetails.views_count }}</p>
            </div>
            <div class="blog-count mr-3 d-align" @click="scrollToComment()">
              <image-view
                :src="'/img/avatars/speech-bubble.png'"
                class="mr-1"
              ></image-view>
              <p class="mb-0">{{ commentNumber }}</p>
            </div>
            <div class="blog-count d-align">
              <image-view
                :src="'/img/avatars/like.png'"
                class="mr-1"
              ></image-view>
              <p class="mb-0">{{ newsDetails.likes_count }}</p>
            </div>
          </div>
        </div>
      </div>
      <hr class="my-4" />
      <div class="col-sm-12 p-0">
        <h5>
          <b>Tags</b>
        </h5>
        <div class="chip-list">
          <v-chip
            v-for="(tag, i) in newsDetails.tags"
            :key="i"
            class="text-capitalize cursor mr-2"
            label
          >
            <router-link
              :to="{ name: 'News Listing', params: { tag: tag } }"
              tag="h5"
              class="text-capitalize m-0"
              >{{ tag }}</router-link
            >
          </v-chip>
        </div>
      </div>
      <hr class="my-4" />
      <p class="el-tiptap-editor__content" v-html="newsDetails.description"></p>
      <div class="col-sm-12 p-0">
        <div class="d-just-space mb-4">
          <div class="d-flex">
            <!-- <v-btn color="success" class="mr-4">Comment</v-btn> -->
            <h5 class="m-0">{{ commentNumber }} Comments</h5>
          </div>
          <p
            v-if="commentNumber > 3"
            class="m-0 cursor"
            @click="showAllComments()"
          >
            Show all comments
          </p>
        </div>
      </div>
      <!-- ..... -->
      <div class="col-sm-12 p-0">
        <div
          v-for="(comment, i) in commentDetails"
          :key="i"
          class="mt-3 border-bottom"
        >
          <p class="mb-0">
            <b>{{ comment.commented_by.full_name }}</b>
          </p>
          <p class="mb-2">{{ getCommentDate(comment.created_at) }}</p>
          <div class="col-sm-12 p-0 d-flex">
            <div class="col-sm-11 p-0">
              <p>{{ comment.comment }}</p>
            </div>
            <div
              @click="openSwal('delete-comment', comment._id)"
              class="col-sm-1 py-0 flex-end"
            >
              <deleteSVG class="cursor w-1" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader v-if="showLoader"></loader>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import "@/assets/scss/_blogs.scss";
const Image = () => import("@/components/image.vue");
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const ShareBlogs = () => import("@/components/modals/shareBlog.vue");
const loader = () => import("@/components/loader.vue");
import { pickSvg } from "@/views/SVG";
import { bus } from "@/main.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showLoader: false,
      slug: this.$route && this.$route.params && this.$route.params.slug,
      newsTitle:
        this.$route && this.$route.params && this.$route.params.newsTitle,
      newsDetails: {},
      dayJS,
      currentPage: 1,
      recordPerPage: 3,
      commentDetails: [],
      commentNumber: "",
    };
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  created() {
    localStorage.setItem(
      "currentPathName",
      `/news/${this.slug}${this.newsTitle ? `/${this.newsTitle}` : ""}`
    );

    bus.$emit("CHAT_BREADCRUMB_CHANGE", [
      {
        text: "Home",
        disabled: !this.permissions.includes("VIEW_DASHBOARD"),
        to: "/",
      },
      {
        text: "News Listing",
        disabled: false,
        to: "/newsListing",
      },
      {
        text: this.newsTitle,
        disabled: true,
        to: this.$route.path,
      },
    ]);
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("currentPathName");
    bus.$emit("CHAT_BREADCRUMB_CHANGE", []);
    next();
  },
  mounted() {
    this.getNewsDetails();
    this.getComments();
  },
  components: {
    Datepicker,
    "image-view": Image,
    "share-blogs": ShareBlogs,
    ...pickSvg("deleteSVG"),
    loader,
  },
  methods: {
    getNewsDetails() {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/news/${this.slug}`;
      this.$http.get(url, {}).then((response) => {
        if (response.body.status) {
          if (response.body.data) {
            this.showLoader = false;
            this.newsDetails = { ...response.body.data };
            bus.$emit("CHAT_BREADCRUMB_CHANGE", [
              {
                text: "Home",
                disabled: !this.permissions.includes("VIEW_DASHBOARD"),
                to: "/",
              },
              {
                text: "News Listing",
                disabled: false,
                to: "/newsListing",
              },
              {
                text: this.newsDetails.title,
                disabled: true,
                to: this.$route.path,
              },
            ]);
          } else {
            this.showLoader = false;
            this.newsDetails = {};
          }
        }
      });
    },
    showAllComments() {
      this.recordPerPage = this.commentNumber;
      this.getComments();
    },
    getComments() {
      this.commentDetails = {};
      let url = `${config.BASE_URL}api/v2/news/comment/${this.slug}`;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
      };
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.commentNumber = response.body.data.count;
          if (response.body.data.list) {
            this.commentDetails = response.body.data.list;
          } else {
            this.commentDetails = {};
          }
        }
      });
    },
    getNewsDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },
    getCommentDate(date) {
      return dayJS(date).format("DD/MM/YYYY hh:mm a");
    },
    openSwal(status, id) {
      if (status === "delete") {
        Swal.fire({
          title: "Are you sure you want to Delete this news",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteNews(id);
          }
        });
      } else if (status === "unpublish") {
        Swal.fire({
          title: "Are you sure you want to Unpublish this news",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateNews(status, id);
          }
        });
      } else if (status === "delete-comment") {
        Swal.fire({
          title: "Are you sure you want to Delete this comment",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteComment(id);
          }
        });
      } else {
        Swal.fire({
          title: "Are you sure you want to Publish this news",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateNews(status, id);
          }
        });
      }
    },
    deleteComment(id) {
      let url = `${config.BASE_URL}api/v2/admin/news/comment/${id}`;
      this.$http.delete(url, {}).then((response) => {
        if (!!response.body.status) {
          Swal.fire({
            toast: true,
            html: "<p> <b>" + "Comment Deleted Successfully" + "</b></p>",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            position: "bottom",
            customClass: "bottom-swal",
            timer: 6000,
          });
        }
        this.commentDetails = {};
        this.getComments();
      });
    },
    updateNews(status, id) {
      let obj = {
        title: this.newsDetails.title,
        cover_photo: this.newsDetails.cover_photo,
        // short_description: this.newsDetails.short_description,
        description: this.newsDetails.description,
        category: this.newsDetails.category,
        tags: this.newsDetails.tags,
        status: status,
      };
      let url = `${config.BASE_URL}api/v2/admin/news/${id}`;
      this.$http.put(url, obj).then((response) => {
        if (!!response.ok) {
          Swal.fire({
            title:
              status === "publish"
                ? "News Published Successfully"
                : "News Unpublished Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              this.goTo("/newsListing");
            }
          });
        }
      });
    },

    deleteNews(id) {
      let url = `${config.BASE_URL}api/v2/admin/news/${id}`;
      this.$http.delete(url, {}).then((response) => {
        if (!!response.ok) {
          Swal.fire({
            title: "News Deleted Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              this.goTo("/newsListing");
            }
          });
        }
      });
    },

    goTo(url) {
      this.$router.push(url);
    },
  },
};
</script>